import React, { useState } from 'react'

import { ProjectOther } from '../../../store/project/types'
import { SimilarProjectCard } from './SimilarProjectCard/SimilarProjectCard'
import styles from './similarProjects.module.scss'

interface SimilarProjectsProps {
  other: ProjectOther[]
  currentProject: string
}

export const SimilarProjects = ({
  other,
  currentProject,
}: SimilarProjectsProps) => {
  const [showAll, setShowAll] = useState(3)

  const handleShowAll = () => {
    setShowAll(other.length)
  }

  const handleCloseAll = () => {
    setShowAll(3)
  }

  return (
    <div className={styles.similarWrapper}>
      <h2>Похожие проекты</h2>
      <div className={styles.similarCards}>
        {other?.slice(0, showAll).map((item, index) => (
          <SimilarProjectCard
            key={index}
            data={item}
            currentProject={currentProject}
          />
        ))}
      </div>
      {other.length > 3 && (
        <div>
          {showAll === 3 ? (
            <button onClick={handleShowAll}>Все проекты</button>
          ) : (
            <button onClick={handleCloseAll}>Скрыть проекты</button>
          )}
        </div>
      )}
    </div>
  )
}
